module.exports = __webpack_public_path__ + "img/ve4.396716ea.png";